import { Apartments_Types, ApartmentsTypes_AR } from "../Helper/data_static";

const view_apartment_type_ar = (item) => {
  switch (item?.type) {
    case Apartments_Types.villa:
      return ApartmentsTypes_AR.villa;
    case Apartments_Types.apartment:
      return ApartmentsTypes_AR.apartment;
    case Apartments_Types.studio:
      return ApartmentsTypes_AR.studio;
    case Apartments_Types.chalet:
      return ApartmentsTypes_AR.chalet;
    case Apartments_Types.hut:
      return ApartmentsTypes_AR.hut;
    case Apartments_Types.break:
      return ApartmentsTypes_AR.break;
    case Apartments_Types.room:
      return ApartmentsTypes_AR.room;
    default:
      return 'شقة';
  }
}
export default view_apartment_type_ar;